/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { TextField } from '@locus-taxy/neo-ui';
import { rankWith, uiTypeIs } from '@jsonforms/core';

import useControlProps from '../util/useControlProps';

type Props = {};

export const ArrayTextFieldControl = (props: Props): React.Node => {
    const {
        label,
        description,
        path,
        data,
        handleChange,
        visible,
        required,
        errors,
        enabled
    } = useControlProps(props);

    return (
        visible && (
            <TextField
                label={label}
                value={data && data.length > 0 ? data[0] : ''}
                fullWidth
                required={required}
                error={errors}
                disabled={!enabled}
                helperText={errors ? errors : description}
                onChange={value => handleChange(path, value ? [value] : [])}
            />
        )
    );
};

export default ArrayTextFieldControl;

export const arrayTextFieldControlTester = rankWith(
    1,
    uiTypeIs('ArrayTextFieldControl')
);
